import {Input} from "@angular/core";
import {VALUE_TYPE} from "../../enums/enums";
import {IDocument} from "../../interfaces/document.definition";


export class GoBaseComponent {
    public VALUE_TYPE = VALUE_TYPE;
    private _document: IDocument;

    @Input() set document(v:IDocument) {
      this._document = v;
      this.onDocumentSet();
    }

    get component() { return this.document[this.componentType]; }
    get document() { return this._document; }


    constructor(public componentType:string) {
    }


    protected onDocumentSet() {

    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-base.component.ts